import { inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { ProductSubcategoriesActions } from './product-subcategories.actions';
import { DpProductSubcategoriesApiService } from '@app/core/services/api/product-subcategories-api.service';

import { DpProductSubcategoriesModel } from '../models';

export const loadProductSubcategoriesEffect = createEffect(
  (actions$ = inject(Actions), apiService = inject(DpProductSubcategoriesApiService)) =>
    actions$.pipe(
      ofType(ProductSubcategoriesActions.loadProductSubcategories),
      switchMap(({ productCatalog, categoryCode }) =>
        apiService.getSubcategoriesById(productCatalog, categoryCode).pipe(
          map((dto) => new DpProductSubcategoriesModel(dto)),
          map((categories) => ProductSubcategoriesActions.loadProductSubcategoriesSuccess({ categories }))
        )
      )
    ),
  { functional: true }
);
